<template>
    <div class="assets-tablets-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'assetsSummary' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Tablets Details
                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'assetsCreate' })">Create</button>
                            <button class="btn btn-ecdc ml-3" @click="$router.push({ name: 'assetsTransfer' })">Transfer</button>
                            <button class="btn btn-ecdc" @click="exportExcel">Export Report</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                Transfer updated successfully.
            </div>
            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>

            <hr />

            <div class="reference-card">

                <h2 class="section-title">Showing Results For:</h2>
              
                <div class="table-responsive">
                    <table class="table table-striped result-table reference-table">
                        <thead>
                            <tr>
                                <th>Division</th>
                                <th>Region</th>
                                <th>Area</th>
                                <th class="text-right">Available</th>
                                <th class="text-right">Occupied</th>
                                <th class="text-right">Damaged</th>
                                <th class="text-right">Transferring</th>
                                <th class="text-right">Pending Receive</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>{{ areaData.division === 1 ? 'South' : 'North' }}</td>
                                <td>{{ areaData.region }}</td>
                                <td>{{ areaData.name }}</td>
                                <td class="text-right">{{ (areaData.available-areaData.transferring) }}</td>
                                <td class="text-right">{{ areaData.occupied }}</td>
                                <td class="text-right">{{ areaData.damaged }}</td>
                                <td class="text-right">{{ areaData.transferring }}</td>
                                <td class="text-right">{{ areaData.pending_receive }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row">
                <div :class="toggleFilter ? 'col-lg-12' : 'col-lg'">
                    <div class="">
                        <ul class="nav custom-tab">
                            <li class="nav-link pointer" @click="showInventory" :class="{ active: showInventoryStatus }">Inventory</li>
                            <li class="nav-link pointer" @click="showTransfer" :class="{ active: showTransferStatus }">Transfer</li>
                            <li class="nav-link pointer" @click="showReceive" :class="{ active: showReceiveStatus }">Receive</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div>

                            <select class="custom-select form-control" v-model="filter">
                                <option value="">All</option>
                                <option v-if="showInventoryStatus" value="available">Available</option>
                                <option v-if="showInventoryStatus" value="occupied">Occupied</option>
                                <option v-if="showInventoryStatus" value="damaged">Damaged</option>
                                <option v-if="showTransferStatus" value="transferring">Transferring</option>
                                <option v-if="showTransferStatus" value="transferred">Transferred</option>
                                <option v-if="showReceiveStatus" value="received">Received</option>
                                <option v-if="showReceiveStatus" value="pending receive">Pending Receive</option>
                            </select>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="applyFilter">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="resetFilter">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">
                    <transition name="fade" mode="out-in">
                        <div v-if="showInventoryStatus">
                            <div class="table-options row justify-content-between align-items-center">
                                <div class="col-sm">
                                    <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

<!--                                    <div class="table-search form-inline d-inline-block ml-4">-->
<!--                                        <input type="text" class="form-control" placeholder="Search by keyword">-->
<!--                                        <button type="button" class="btn btn-ecdc btn-circle">-->
<!--                                            <app-icon-search></app-icon-search>-->
<!--                                        </button>-->
<!--                                    </div>-->

                                    <transition name="fade" mode="out-in">
                                        <button v-if="SelectedBulk.length" class="btn btn-ecdc ml-4" @click="applyModalBulkData">Update Status</button>
                                    </transition>
                                </div>
                                <div class="col-sm mt-3 mt-sm-0">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateTop"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-striped table-hover result-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>IMEI Number</th>
                                            <th>Create Date</th>
                                            <th>Last Update</th>
                                            <th>Status</th>
                                            <th width="200">Remarks</th>
                                            <th class="text-center" width="180">Action</th>
                                            <th class="text-center">Bulk Update</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr :key="data.id" v-for="data in tabletData">
                                            <td>{{ data.sku | capitalize }}</td>
                                            <td>{{ data.imei }}</td>
                                            <td>{{ data.created_at }}</td>
                                            <td>{{ data.updated_at }}</td>
                                            <td>{{ data.status | capitalize }}</td>
                                            <td>{{ data.remarks }}</td>
                                            <td class="text-center" >
                                                <button class="btn btn-link btn-icon icon-right" @click="applyModalData(data)">
                                                    Update Status
                                                    <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                                </button>
                                            </td>
                                            <td class="text-center">
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" :value="data.id" class="custom-control-input" :id="data.id" v-model="SelectedBulk">
                                                    <label class="custom-control-label" :for="data.id"></label>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row justify-content-between align-items-center table-options">
                                <div class="col-lg col-6">
                                    <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                        <option value="15">15</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    per page
                                </div>
                                <div class="col-lg text-right text-lg-center col-6">
                                    {{ showingResults }}
                                </div>
                                <div class="col-lg mt-lg-0 col-6">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateBottom"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>

                                </div>
                            </div>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div v-if="showTransferStatus">
                            <div class="table-options row justify-content-between align-items-center">
                                <div class="col-lg">
                                    <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc">Filter</button>

<!--                                    <div class="table-search form-inline d-inline-block ml-4">-->
<!--                                        <input type="text" class="form-control" placeholder="Search by keyword">-->
<!--                                        <button type="button" class="btn btn-ecdc btn-circle">-->
<!--                                            <app-icon-search></app-icon-search>-->
<!--                                        </button>-->
<!--                                    </div>-->

                                    <transition name="fade" mode="out-in">
                                        <button v-if="SelectedBulk.length" class="btn btn-ecdc ml-4" @click="applyModalBulkData">Update Status</button>
                                    </transition>
                                </div>
                                <div class="col-lg">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateTop"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-striped table-hover result-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>IMEI Number</th>
                                            <th>Create Date</th>
                                            <th>Last Update</th>
                                            <th>Status</th>
                                            <th>Target Area</th>
                                            <th>Transfer Form</th>
                                            <th width="200">Remarks</th>
                                            <th class="text-center" width="180">Action</th>
                                            <th class="text-center">Bulk Update</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr :key="transfer.id" v-for="transfer in transferData" :class="(transfer.from_status === 'transferred' || transfer.from_status === 'canceled')? 'archived' : ''">
                                            <td>{{ transfer.tablet.sku | capitalize }}</td>
                                            <td>{{ transfer.tablet.imei }}</td>
                                            <td>{{ transfer.created_at }}</td>
                                            <td>{{ transfer.updated_at }}</td>
                                            <td>{{ transfer.from_status | capitalize }}</td>
                                            <td>{{ transfer.to_area.name }}</td>
                                            <td><span class="pointer">View Photo</span></td>
                                            <td>{{ transfer.from_remarks }}</td>
                                            <td class="text-center" >
                                                <div v-if="transfer.from_status === 'transferring'">
                                                    <button class="btn btn-link btn-icon icon-right" @click="applyTransferReceiveModalData(transfer)">
                                                        Update Status
                                                        <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                                    </button>
                                                </div>

                                            </td>
                                            <td class="text-center">
                                                <div v-if="transfer.from_status === 'transferring'">
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" :value="transfer.id" class="custom-control-input" :id="transfer.id" v-model="SelectedBulk">
                                                        <label class="custom-control-label" :for="transfer.id"></label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row justify-content-between table-options">
                                <div class="col-lg">
                                    <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                        <option value="15">15</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    per page
                                </div>
                                <div class="col-lg text-center">
                                    {{ showingResults }}
                                </div>
                                <div class="col-lg">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateBottom"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>

                                </div>
                            </div>
                        </div>
                    </transition>
                    
                    <transition name="fade" mode="out-in">
                        <div v-if="showReceiveStatus">
                            <div class="table-options row justify-content-between align-items-center">
                                <div class="col-lg">
                                    <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc">Filter</button>

<!--                                    <div class="table-search form-inline d-inline-block ml-4">-->
<!--                                        <input type="text" class="form-control" placeholder="Search by keyword">-->
<!--                                        <button type="button" class="btn btn-ecdc btn-circle">-->
<!--                                            <app-icon-search></app-icon-search>-->
<!--                                        </button>-->
<!--                                    </div>-->

                                    <transition name="fade" mode="out-in">
                                        <button v-if="SelectedBulk.length" class="btn btn-ecdc ml-4" @click="applyModalBulkData">Update Status</button>
                                    </transition>
                                </div>
                                <div class="col-lg">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateTop"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-striped table-hover result-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>IMEI Number</th>
                                            <th>Create Date</th>
                                            <th>Last Update</th>
                                            <th>Status</th>
                                            <th>From Area</th>
                                            <th>Transfer Form</th>
                                            <th width="200">Remarks</th>
                                            <th class="text-center" width="180">Action</th>
                                            <th class="text-center">Bulk Update</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    <tr :key="receive.id" v-for="receive in receiveData" :class="receive.to_status !== 'pending receive' ? 'archived' : ''">
                                        <td>{{ receive.tablet.sku | capitalize }}</td>
                                        <td>{{ receive.tablet.imei }}</td>
                                        <td>{{ receive.created_at }}</td>
                                        <td>{{ receive.updated_at }}</td>
                                        <td>{{ receive.to_status | capitalize }}</td>
                                        <td>{{ receive.from_area.name }}</td>
                                        <td><span class="pointer"></span></td>
                                        <td class="transfer-remarks">
                                            <div v-if="receive.from_remarks">
                                                <small>Transferer:</small>
                                                <figcaption>
                                                {{ receive.from_remarks | capitalize }} 
                                                </figcaption>
                                            </div>
                                            
                                            <div v-if="receive.to_remarks">
                                                <small>Receiver:</small>
                                                <figcaption>
                                                {{ receive.to_remarks | capitalize }}
                                                </figcaption>
                                            </div>
                                        </td>
                                        <td class="text-center" >
                                            <div v-if="receive.to_status === 'pending receive'">
                                                <button class="btn btn-link btn-icon icon-right" @click="applyTransferReceiveModalData(receive)">
                                                    Confirm Receive
                                                    <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                                </button>
                                            </div>

                                        </td>
                                        <td class="text-center">
                                            <div v-if="receive.to_status === 'pending receive'">
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" :value="receive.id" class="custom-control-input" :id="receive.id" v-model="SelectedBulk">
                                                    <label class="custom-control-label" :for="receive.id"></label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row justify-content-between table-options">
                                <div class="col-lg">
                                    <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                        <option value="15">15</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    per page
                                </div>
                                <div class="col-lg text-center">
                                    {{ showingResults }}
                                </div>
                                <div class="col-lg">
                                    <app-paginate
                                        :page-count="totalPage"
                                        :click-handler="pagination"
                                        :prev-text="'&laquo;'"
                                        :next-text="'&raquo;'"
                                        ref="paginateBottom"
                                        :container-class="'pagination justify-content-end'">
                                    </app-paginate>

                                </div>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>
        </div>

        <b-modal id="asset-status" hide-header hide-footer centered size="s">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('asset-status')" /> 

            <div class="selection-modal modal-form">
                <h4 class="title text-left mb-4" v-if="showTransferStatus || showInventoryStatus">Asset Status</h4>  
                <h4 class="title text-left mb-4" v-if="showReceiveStatus">Confirm Receive</h4>  

                <div class="mb-4">
                    <div :key="tablet.id" v-for="tablet in modal.tablets">
                        {{ tablet.sku }} - {{ tablet.imei }}
                    </div>
                </div>


                <div class="form-group" :class="{ 'form-is-error': $v.modal.status.$error }" v-if="showInventoryStatus" >
                    <label>Status</label>
                    <select class="custom-select form-control" name="status" id="status" required v-model="modal.status">
                        <option value="">-</option>
                        <option value="available">Available</option>
                        <option value="occupied">Occupied</option>
                        <option value="damaged">Damaged</option>
                    </select>

                    <div class="invalid-feedback form-error-msg" v-if="!$v.modal.status.required">Status is required</div>
                </div>
                
                <div class="form-group" v-if="showTransferStatus || showInventoryStatus">
                    <label>Remarks</label>
                    <textarea name="remarks" rows="3" class="form-control" v-model="modal.remarks"></textarea>
                </div>

                <div class="form-group" v-if="showReceiveStatus">
                    <label>Remarks</label>
                    <textarea name="remarks" rows="3" class="form-control" v-model="modal.to_remarks"></textarea>
                </div>

                <div>
                    <button type="button" class="btn btn-ecdc" @click="checkForm" v-if="showTransferStatus || showInventoryStatus">Update</button>
                    <button type="button" class="btn btn-ecdc" @click="checkForm" v-if="showReceiveStatus">Confirm</button>
                    <button v-if="showTransferStatus" type="button" class="float-right btn btn-link text-danger ml-2" @click="cancelTransfer"><font-awesome-icon :icon="['fas', 'minus-circle']" /> Cancel Transfer</button>
                    <!-- <button type="button" class="btn btn-link text-muted" @click="$bvModal.hide('asset-status')">Close</button> -->
                </div>
            </div>            
        </b-modal>

        <app-loader v-show="isLoading"></app-loader>

    </div>
</template>

<script>
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import {
    getTabletsByArea,
    updateTabletsByArea,
    getTabletsByTransfer,
    getTabletsByReceive,
    cancelTabletTransfer,
    exportInventoryTablet
} from "../api";
import { requiredIf } from 'vuelidate/lib/validators';

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_IMAGE_BASE_URL,
            showInventoryStatus:true,
            showTransferStatus:false,
            showReceiveStatus:false,
            SelectedBulk: [],
            isLoading: true,
            isSuccess: false,
            isError: false,
            toggleFilter: true,
            id: '',
            totalPage: 0,
            pageLimit: 15,
            areaData: '',
            tabletData: '',
            transferData: '',
            receiveData: '',
            showingResults: '',
            filter: '',
            modal: {
                type: '',
                tablets: [],
                status: '',
                remarks: '',
                to_remarks: '',
                transferReceiveID: '',
            }
        }
    },
    validations: {
        modal: {
            status: {
                required: requiredIf(function() {
                    return this.showInventoryStatus;
                })
            }
        }
    },
    filters: {
        capitalize: function (value) {

            if(value === '' || value === null) {
                return value;
            }

            value = value.split(" ");

            for (let i = 0, x = value.length; i < x; i++) {
                value[i] = value[i][0].toUpperCase() + value[i].substr(1);
            }

            return value.join(" ");
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.getInventory(1);
        this.isLoading = false;
    },
    methods: {
        async getInventory(pageNum) {
            this.isLoading = true;
            try {
                let result = await getTabletsByArea({filter: this.filter, id: this.id}, pageNum, this.pageLimit);

                this.areaData = result.data.area;
                this.tabletData = result.data.tablets.data;

                this.totalPage = result.data.tablets.total / this.pageLimit;

                if(this.totalPage % 1 !== 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                let startPage = 1;

                if(pageNum !== 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                let endPage = pageNum * this.pageLimit;

                if(endPage >= result.data.tablets.total)
                    endPage = result.data.tablets.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + result.data.tablets.total + " results";

                this.isLoading = false;

            } catch (err) {
                alert(err.response.data.message);
            }
        },
        async getTransfer(pageNum) {
            this.isLoading = true;
            try {
                let result = await getTabletsByTransfer({filter: this.filter, id: this.id}, pageNum, this.pageLimit);
                this.transferData = result.data.transfer.data;

                this.totalPage = result.data.transfer.total / this.pageLimit;

                if(this.totalPage % 1 !== 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                let startPage = 1;

                if(pageNum !== 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                let endPage = pageNum * this.pageLimit;

                if(endPage >= result.data.transfer.total)
                    endPage = result.data.transfer.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + result.data.transfer.total + " results";

                this.isLoading = false;

            } catch (err) {
                alert(err.response.data.message);
            }
        },
        async getReceive(pageNum) {
            this.isLoading = true;
            try {
                let result = await getTabletsByReceive({filter: this.filter, id: this.id}, pageNum, this.pageLimit);
                this.receiveData = result.data.receive.data;

                this.totalPage = result.data.receive.total / this.pageLimit;

                if(this.totalPage % 1 !== 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                let startPage = 1;

                if(pageNum !== 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                let endPage = pageNum * this.pageLimit;

                if(endPage >= result.data.receive.total)
                    endPage = result.data.receive.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + result.data.receive.total + " results";

                this.isLoading = false;

            } catch (err) {
                alert(err.response.data.message);
            }
        },
        async exportExcel() {
            this.isLoading = true;
            try {
                let result = await exportInventoryTablet({id: this.id});

                let fileURL = window.URL.createObjectURL(new Blob([result.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                let moment = require('moment');
                let date = moment().format('YYYYMMDD');

                fileLink.setAttribute('download', 'INVENTORY_TABLET_'+ date +'.xlsx');

                document.body.appendChild(fileLink);
                fileLink.click();

                this.isLoading = false;


            } catch (err) {
                alert(err.response.data.message);
            }
            this.isLoading = false;
        },
        showInventory() {
            this.showInventoryStatus = true;
            this.showTransferStatus = false;
            this.showReceiveStatus = false;
            this.filter = '';
            this.SelectedBulk = [];
            this.getInventory(1);
        },
        showTransfer() {
            this.showInventoryStatus = false;
            this.showTransferStatus = true;
            this.showReceiveStatus = false;
            this.filter = '';
            this.SelectedBulk = [];
            this.getTransfer(1);
        },
        showReceive() {
            this.showInventoryStatus = false;
            this.showTransferStatus = false;
            this.showReceiveStatus = true;
            this.filter = '';
            this.SelectedBulk = [];
            this.getReceive(1);
        },
        async pagination(pageNum) {

            this.isLoading = true;

            if(pageNum !== 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else
                pageNum = this.$refs.paginateBottom.selected;

            await this.getUsers(pageNum);

            this.isLoading = false;
        },
        applyFilter() {

            switch(this.filter) {
                case 'available':
                case 'occupied':
                case 'damaged':
                    this.getInventory(1);
                    break;

                case 'transferred':
                case 'transferring':
                    this.getTransfer(1);
                    break;
                case 'received':
                case 'pending receive':
                    this.getReceive(1);
                    break;
                default:
                    this.getInventory(1);
                    this.getTransfer(1);
                    this.getReceive(1);
                    break;
            }

        },
        resetFilter() {
            this.filter = '';
        },
        applyModalData(data) {
            if(this.showInventoryStatus) {
                this.modal.tablets = [];
                this.modal.status = '';
                this.modal.remarks = '';

                let obj = {
                    id: data.id,
                    imei: data.imei,
                    sku: data.sku
                };

                this.modal.tablets.push(obj);
                this.$bvModal.show('asset-status');
            }
        },
        applyTransferReceiveModalData(data) {
            this.modal.tablets = [];
            this.modal.status = '';
            this.modal.remarks = '';

            this.modal.transferReceiveID = [data.id];

            let obj = {
                id: data.tablet.id,
                imei: data.tablet.imei,
                sku: data.tablet.sku
            };

            this.modal.tablets.push(obj);
            this.$bvModal.show('asset-status');
        },
        applyModalBulkData() {
            let _this = this;
            this.modal.tablets = [];
            this.modal.transferReceiveID = this.SelectedBulk;

            this.SelectedBulk.forEach(value => {

                if(this.showInventoryStatus) {
                    let found = this.tabletData.filter(item => item.id === value);

                    found.forEach(value => {
                        _this.modal.tablets.push(value);
                    });
                }

                if(this.showTransferStatus) {
                    let found = this.transferData.filter(item => item.id === value);

                    found.forEach(value => {
                        _this.modal.tablets.push(value.tablet);
                    });
                }

                if(this.showReceiveStatus) {
                    let found = this.receiveData.filter(item => item.id === value);

                    found.forEach(value => {
                        _this.modal.tablets.push(value);
                    });
                }

            });

            this.$bvModal.show('asset-status');
        },
        checkForm() {
            const _this = this;
            this.$v.modal.$touch();

            if(this.$v.modal.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() {

                    _this.isError = false;
                }, 2000);
            } else {
                this.updateStatus();
            }
        },
        async updateStatus() {

            let _this = this;
            if(this.showInventoryStatus) {
                this.modal.type = 'inventory';
            }

            if(this.showTransferStatus) {
                this.modal.type = 'transfer';
            }

            if(this.showReceiveStatus) {
                this.modal.type = 'receive';
            }

            try {
                await updateTabletsByArea(this.modal);
                this.isSuccess = true;

                this.$bvModal.hide('asset-status');
                this.SelectedBulk = [];
                this.modal.tablets = [];
                this.getInventory(1);

                if(this.showTransferStatus) {
                    this.getTransfer(1);
                }

                if(this.showReceiveStatus) {
                    this.getReceive(1);
                }

                setTimeout(function() {

                    _this.isSuccess = false;
                }, 2000);
            } catch (err) {
                alert(err.response.data.message);
            }
        },
        async cancelTransfer() {
            if(this.showInventoryStatus) {
                this.modal.type = 'inventory';
            }

            if(this.showTransferStatus) {
                this.modal.type = 'transfer';
            }

            if(this.showReceiveStatus) {
                this.modal.type = 'receive';
            }

            await cancelTabletTransfer(this.modal);
            this.$bvModal.hide('asset-status');
            this.SelectedBulk = [];
            this.modal.tablets = [];
            this.getTransfer(1);
            this.getInventory(1);
        }
    },
}
</script>